// 广东华工监理
export default {
    nav: [
        {
            title: '首页',
            href: '/',
            activeReg: /(^\/search*)|(^\/$)/,
        },
        {
            title: '新闻公告',
            href: '/news',
            activeReg: /(^\/news*)/,
        },
        {
            title: '交易中心',
            href: '/business',
            activeReg: /(^\/business*)/,
        },
        {
            title: '帮助中心',
            href: '/guide',
            activeReg: /(^\/guide*)/,
        },
        {
            title: '下载中心',
            href: '/download',
            activeReg: /(^\/download*)/,
        },
        // {
        //     title: 'CA在线办理',
        //     href: '/online',
        //     activeReg: /(^\/online*)/,
        //     // click:`window.open('http://hebcaonline.hebca.com:9001/Hebca/certbussconduct/entry.action?onlineType=4&projectType=zbrhah&cztype=1')`
        // },
        {
            title: '关于我们',
            href: '/about',
            activeReg: /(^\/about*)/,
        },
    ],
    head: {
        title: '华工监理电子招投标交易平台',
        title2: '华工监理',
        jc_title: '华工监理',//简称
        citycode:'440000',//城市编号
        planName:'gdhg',
        meta: {
            description: '华工监理电子招投标交易平台,交易平台,招投标,电子交易平台',
            keywords: '华工监理电子招投标交易平台,交易平台,招投标,电子交易平台',
        },
        favicon: '/gdhg/favicon.ico',
        logoUrl:"/gdhg/images/logo.png",//首页LOGO
        registerImg: '/gdhg/images/register_logo.png',//注册页面LOGO
        bannerImg: '/gdhg/images/banner.png',
        bannerList:[
            {
                linkimg:'/gdhg/images/banner.png',
                linkurl:''
            }
        ],
        // 用户角色登录
        userRoles: [
            {
                imgsrc: '/img/hzzlogin/zb.png',
                href: 'http://gdhgdl.zchzb.com/otc/#/login?plan=gdhg&mRole=agent',
                title: '代理机构登录',
                class: 'gcjs',
            },
            {
                imgsrc: '/img/hzzlogin/tb.png',
                href: 'http://gdhgtb.zchzb.com/newtbr/index.html#/login?plan=gdhg',
                title: '供应商登录',
                class: 'zfcg',
            },
            {
                imgsrc: '/img/hzzlogin/pb.png',
                href: 'http://gdhgpb.zchzb.com',
                title: '专家登录',
                class: 'zj'
            },
            {
                imgsrc: '/img/hzzlogin/cg.png',
                href: 'http://gdhgdl.zchzb.com/otc/#/login?plan=gdhg&mRole=tender',
                title: '采购人登录',
                class: 'qycg',
            },
        ],
        friendLinks:[
            {
                href: 'http://www.cebpubservice.com/',
                title: '中国招投标公共服务平台'
            },
            {
                href: 'http://www.ccgp.gov.cn/',
                title: '中国政府采购网'
            },
            {
                href: 'https://www.creditchina.gov.cn/',
                title: '信用中国'
            },
            {
                href: 'https://wenshu.court.gov.cn/',
                title: '中国裁判文书网'
            }, 
            {
                href: '',
                title: ''
            },
            {
                href: '',
                title: ''
            },
        ],
        tel: '020-88138686', //客服电话
        tel2: '',//备用电话/其他电话
        fax: '',//传真号码
        email: 'huagongjianli@163.com', //邮箱地址
        workTime: '',//工作时间
        postalCode: '510641',//邮政编码
        companyName: '广东华工工程建设监理有限公司',  //运营公司名称
        companyAddress: '广州市天河区五山路373号华南理工大学科技园金华园区',//公司地址
        companyLatLng:{ lng: 113.35, lat: 23.16 },//公司地址坐标,
        showWeather: false,//是否显示天气
        icp:'粤ICP备05013117号',
        gwIcp:'',
        products: [
            {
                title: 'xxxx',
                href: 'xxxxx'
            },
        ],
        isCheckOtherSingleCertCode: true, //注册页面 是否校验 其他一证一照代码
        isNotZfcg: true,//没有政府采购
    },
    proxy: {
        '/web': {
            target: 'http://gdhg.zchzb.com/',
            changeOrigin:true,
        },
    },
}